import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';

@Component
export default class formMixin extends Vue {

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    categoryId: [
      { required: true, message: '课程分类不能为空' },
    ],
    learningType: [
      { required: true, message: '授课形式不能为空' },
    ],
    learningNum: [
      { required: true, message: '开班形式不能为空' },
    ],
    learningTime: [
      { required: true, message: '授课时长不能为空' },
    ],
    standardHour: [
      { required: true, message: '标准课时不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
